"use strict";

const FETCH_USER_LIST_REQUEST = "FETCH_USER_LIST_REQUEST";
const FETCH_USER_LIST_SUCCESS = "FETCH_USER_LIST_SUCCESS";
const FETCH_USER_LIST_ERROR = "FETCH_USER_LIST_ERROR";
const FETCH_USER_LIST_SEARCH = "FETCH_USER_LIST_SEARCH";
const ADD_USER_REQUEST = "ADD_USER_REQUEST";
const ADD_USER_SUCCESS = "ADD_USER_SUCCESS";
const ADD_USER_ERROR = "ADD_USER_ERROR";
const DELETE_USER_REQUEST = "DELETE_USER_REQUEST";
const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
const DELETE_USER_ERROR = "DELETE_USER_ERROR";
const CLOSE_SUCCESS_USER_POPUP = "CLOSE_SUCCESS_USER_POPUP";
const DELETE_USER_POPUP_TITLE = "DELETE USER";
const DELETE_USER_CONFIRMATION_POPUP = "DELETE_USER_CONFIRMATION_POPUP";
const USER_ADDED_SUCCESSFULLY_MESSAGE ="User added successfully"
const USER_DELETED_SUCCESSFULLY_MESSAGE ="User deleted successfully"
const ALREADY_USER_ADDED_MESSAGE ="User already exist"
const ALREADY_USER_DELETED_MESSAGE ="User already deleted"
const USER_NOT_FOUND_IN_WORKSPACE_MESSAGE = "User doesn't exist"
const VIEWER = "Viewer"
const USER_DELETION_CONFIRMATION_MESSAGE ="Do you really want to delete the user ? Press OK to delete ,Cancel to abort"
const UNAUTHORIZED_USER = "You are not authorized to perform this action.Please contact DxS IntelliServe Support"
const NO_DATA_FOUND ="No Data Found";
const GENERIC_FAILED= "Add or Delete operation failed due to technical error, Please try again"

export {
  FETCH_USER_LIST_REQUEST,
  FETCH_USER_LIST_SUCCESS,
  FETCH_USER_LIST_ERROR,
  FETCH_USER_LIST_SEARCH,
  ADD_USER_REQUEST,
  ADD_USER_SUCCESS,
  ADD_USER_ERROR,
  DELETE_USER_REQUEST,
  DELETE_USER_SUCCESS,
  DELETE_USER_ERROR,
  CLOSE_SUCCESS_USER_POPUP,
  DELETE_USER_POPUP_TITLE,
  USER_ADDED_SUCCESSFULLY_MESSAGE,
  USER_DELETION_CONFIRMATION_MESSAGE,
  DELETE_USER_CONFIRMATION_POPUP,
  USER_DELETED_SUCCESSFULLY_MESSAGE,
  NO_DATA_FOUND,
  ALREADY_USER_ADDED_MESSAGE,
  ALREADY_USER_DELETED_MESSAGE,
  USER_NOT_FOUND_IN_WORKSPACE_MESSAGE,
  UNAUTHORIZED_USER,
  GENERIC_FAILED,
  VIEWER
};